module.exports = __webpack_public_path__ + "static/yiyiyi-logo-75c6b4cef4948c68af947d7b4b47f994.png";